<template>
  <div>
    <div class="box-container" style="text-align: left;">
      <div class="section">
        <h1>证件&银行卡&现金</h1>
        <ul class="list">
          <li v-for="(item, documentNewIndex) in documentNewList" :key="documentNewIndex" v-show="item.selected" @click="adviserClick(item)" v-bind:class="{ 'cheaked' : item.uselected}" style="cursor: pointer">
            <h2>{{ item.name }}</h2>
            <p style="white-space: pre-wrap;word-wrap: break-word;">{{ item.content }}</p>
          </li>
        </ul>
      </div>
      <div class="section">
        <h1>洗漱用品</h1>
        <ul class="list">
          <li v-for="(item, toiletriesIndex) in toiletriesList" :key="toiletriesIndex" v-show="item.selected" @click="adviserClick(item)" v-bind:class="{ 'cheaked' : item.uselected}" style="cursor: pointer">
            <h2>{{ item.name }}</h2>
            <p style="white-space: pre-wrap;word-wrap: break-word;">{{ item.content }}</p>
          </li>
        </ul>
      </div>

      <div class="section">
        <h1>衣物&杂物</h1>
        <ul class="list">
          <li v-for="(item,clothesIndex) in clothesList" :key="clothesIndex" v-show="item.selected" @click="adviserClick(item)" v-bind:class="{ 'cheaked' : item.uselected }" style="cursor: pointer">
            <h2>{{ item.name }}</h2>
            <p style="white-space: pre-wrap;word-wrap: break-word;">{{ item.content }}</p>
          </li>
        </ul>
      </div>

      <div class="section">
        <h1>电子产品</h1>
        <ul class="list">
          <li v-for="(item, electronicsIndex) in electronicsList" :key="electronicsIndex" v-show="item.selected" @click="adviserClick(item)" v-bind:class="{ 'cheaked' : item.uselected }" style="cursor: pointer">
            <h2>{{ item.name }}</h2>
            <p style="white-space: pre-wrap;word-wrap: break-word;">{{ item.content }}</p>
          </li>
        </ul>
      </div>

      <div class="section">
        <h1>药品</h1>
        <ul class="list">
          <li v-for="(item, drugIndex) in drugList" :key="drugIndex" v-show="item.selected" @click="adviserClick(item)" v-bind:class="{ 'cheaked' : item.uselected }" style="cursor: pointer">
            <h2>{{ item.name }}</h2>
            <p style="white-space: pre-wrap;word-wrap: break-word;">{{ item.content }}</p>
          </li>
        </ul>
      </div>
      <div class="section">
        <h1>旅行箱/背包</h1>
        <ul class="list">
          <li v-for="(item, pacIndex) in packageList" :key="pacIndex" v-show="item.selected" @click="adviserClick(item)" v-bind:class="{ 'cheaked' : item.uselected }" style="cursor: pointer">
            <h2>{{ item.name }}</h2>
            <p style="white-space: pre-wrap;word-wrap: break-word;">{{ item.content }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { fetchReadyList } from '@/api/user/account'
export default {
  name: 'readylist',
  components: {},
  data () {
    return {
      rid: this.$route.query.rid,
      uid: this.$route.query.uid,
      heading: '',
      documentNewList: [],
      clothesList: [],
      drugList: [],
      electronicsList: [],
      packageList: [],
      toiletriesList: [],
      selectList: [],
      order: ''
    }
  },
  created () {
    this.readylistCtrl()
  },
  mounted () {
  },
  methods: {
    // 准备清单
    readylistCtrl () {
      let requestParams = {}
      requestParams.readyId = this.rid
      fetchReadyList(requestParams).then(response => {
        this.heading = response.data.heading
        this.documentNewList = response.data.checkList.document
        this.clothesList = response.data.checkList.clothes
        this.drugList = response.data.checkList.drug
        this.electronicsList = response.data.checkList.electronics
        this.packageList = response.data.checkList.package
        this.toiletriesList = response.data.checkList.toiletries
      }, function (error) {
        console.log(error)
      })
    },
    // 清单点击事件
    adviserClick (item) {
      item.uselected = !item.uselected
      this.selectList = []
      this.callSelectlistPush()
    },
    // 清单组合记录
    callSelectlistPush () {
      if (this.documentNew) {
        this.documentNew.forEach(function (itemxx) {
          if (itemxx.uselected) {
            this.selectList.push(itemxx.name)
          }
        })
      }
      if (this.clothes) {
        this.clothes.forEach(function (itemxx) {
          if (itemxx.uselected) {
            this.selectList.push(itemxx.name)
          }
        })
      }
      if (this.electronics) {
        this.electronics.forEach(function (itemxx) {
          if (itemxx.uselected) {
            this.selectList.push(itemxx.name)
          }
        })
      }
      if (this.toiletries) {
        this.toiletries.forEach(function (itemxx) {
          if (itemxx.uselected) {
            this.selectList.push(itemxx.name)
          }
        })
      }
      if (this.drug) {
        this.drug.forEach(function (itemxx) {
          if (itemxx.uselected) {
            this.selectList.push(itemxx.name)
          }
        })
      }
      if (this.package) {
        this.package.forEach(function (itemxx) {
          if (itemxx.uselected) {
            this.selectList.push(itemxx.name)
          }
        })
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
  font-size: 62.5%;
  font-weight: 400;
  background-color: hsl(360, 0%, 96%);
  margin: auto;
  padding-bottom: 30px;
  overflow-x: hidden;
  position: relative;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
nav,
ul,
li,
h1,
h2,
p,
img,
a,
header,
i {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
  cursor: pointer;
  color: #4990E2;
}
a:hover {
  opacity: 0.8;
}
* {
  line-height: 1.6em;
  font-size: 13px;
}
.section {
  margin-bottom: 0;
}
.bg-danger {
  display: none;
}
footer {
  display: none;
}
header {
  width: 100%;
  height: 60px;
  background-color: #E60012;
  color: white;
  text-align: center;
  display: none;
}
header h1 {
  font-weight: 600;
  font-size: 18px;
  line-height: 60px;
}
header h1 span {
  font-weight: 600;
  font-size: 18px;
  line-height: 60px;
}
.section h1 {
  font-size: 15px;
  padding: 1.1em 12px;
  position: relative;
  font-weight: 500;
  background-color: #E60012;
  color: white;
}
.section h1 i {
  position: absolute;
  display: block;
  width: 20px;
  height: 12px;
  top: 22px;
  right: 20px;
  vertical-align: center;
}
.section h1 i img {
  width: 10px;
  vertical-align: center;
  transition: 0.3s ease-in-out;
  transform: rotate(180deg);
}
.section > .list {
  background-color: white;
}
.section > .list li {
  position: relative;
  margin-top: 1px;
}
.section .cheaked::after {
  content: '已带';
  position: absolute;
  font-size: 11px;
  padding: 0 0.6em;
  line-height: 1.6em;
  border-radius: 3px;
  color: white;
  background-color: rgb(134, 202, 60);
  border: 1px solid rgb(134, 202, 60);
  right: 18px;
  top: 13px;
}
.cheaked {
  background-color: rgba(134, 202, 60, 0.06);
}
.section > .list h2 {
  font-size: 16px;
  color: hsl(0, 0%, 20%);
  font-weight: 600;
  padding: 0.8em 56px 0.3em 12px;
}
.section > .list p {
  font-size: 14px;
  color: hsl(0, 0%, 60%);
  padding: 0 24px 1.2em 12px;
}
@media (min-width: 767px) {
  html {
    background-color: hsl(360, 0%, 96%);
  }
  body {
    background-color: hsl(360, 0%, 96%);
  }
  header {
    display: block;
  }
  .box-container {
    padding-top: 20px;
    width: 98%;
    background-color: hsl(360, 0%, 96%);
    margin: auto;
    column-count: 2;
    column-gap: 0;
    text-align: left;
  }
  .section {
    break-inside: avoid;
    padding: 12px;
  }
}
@media (min-width: 1120px) {
  .box-container {
    width: 80%;
    background-color: hsl(360, 0%, 96%);
    column-count: 3;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/user/readylist.vue